import { apiSlice } from "./apiSlice";

/** One row of the Admin Emmi access list (SCRUM-706). */
export interface AdminAccessEntry {
  id: number;
  email: string | null;
  first_name: string;
  last_name: string;
  is_super_admin: boolean;
  created_at: string;
}

export interface GrantAdminAccessArgs {
  email: string;
}

export const adminAccessApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAdminAccess: builder.query<AdminAccessEntry[], void>({
      query: () => ({
        url: "/admin-access",
        method: "GET",
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({
                type: "AdminAccess" as const,
                id,
              })),
              { type: "AdminAccess" as const, id: "LIST" },
            ]
          : [{ type: "AdminAccess" as const, id: "LIST" }],
    }),
    grantAdminAccess: builder.mutation<AdminAccessEntry, GrantAdminAccessArgs>({
      query: (body) => ({
        url: "/admin-access",
        method: "POST",
        data: body,
      }),
      invalidatesTags: (result, error) =>
        error ? [] : [{ type: "AdminAccess", id: "LIST" }],
    }),
    revokeAdminAccess: builder.mutation<AdminAccessEntry, number>({
      query: (id) => ({
        url: `/admin-access/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error) =>
        error ? [] : [{ type: "AdminAccess", id: "LIST" }],
    }),
  }),
});

export const {
  useGetAdminAccessQuery,
  useGrantAdminAccessMutation,
  useRevokeAdminAccessMutation,
} = adminAccessApi;
